export default __webpack_public_path__ + "static/media/birds.12529760.jpg";